// Pantera Market — scripts propios (vanilla JS, sin librerias externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initMarquesinas();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
  initFaqAcordeon();
  initComparadorDeslizante();
  initTiltTarjetas();
});

function initReveals() {
  var els = document.querySelectorAll('.pt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('pt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-retraso') || 0;
        setTimeout(function () { entry.target.classList.add('pt-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesinas() {
  document.querySelectorAll('[data-pt-marquesina]').forEach(function (wrap) {
    var track = wrap.querySelector('.pt-marquesina-track');
    if (!track || track.dataset.duplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicado = '1';
  });
}

function initCifras() {
  var els = document.querySelectorAll('[data-pt-cifra]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-pt-cifra'));
      var sufijo = el.getAttribute('data-sufijo') || '';
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        var val = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0 ? Math.round(val) : val.toFixed(1)) + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-pt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-pt-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-pt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-src');
        var srcset = mini.getAttribute('data-srcset');
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.remove('pt-mini-activa'); });
        mini.classList.add('pt-mini-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-pt-form-producto]').forEach(function (form) {
    var dataEl = form.querySelector('[data-pt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-pt-opcion]');
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-pt-precio]');
    var precioCompareEl = form.querySelector('[data-pt-precio-comparado]');
    var botonComprar = form.querySelector('[data-pt-boton-comprar]');

    function moneda(centavos) {
      return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || botonComprar.textContent;
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initFaqAcordeon() {
  document.querySelectorAll('[data-pt-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-pt-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('pt-faq-abierta');
      item.closest('[data-pt-faq-lista]').querySelectorAll('[data-pt-faq-item]').forEach(function (i) {
        i.classList.remove('pt-faq-abierta');
      });
      if (!abierto) item.classList.add('pt-faq-abierta');
    });
  });
}

function initComparadorDeslizante() {
  document.querySelectorAll('[data-pt-comparador]').forEach(function (comp) {
    var handle = comp.querySelector('[data-pt-comparador-asa]');
    var despues = comp.querySelector('[data-pt-comparador-despues]');
    if (!handle || !despues) return;
    var arrastrando = false;

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
      despues.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) { arrastrando = true; handle.setPointerCapture(e.pointerId); });
    handle.addEventListener('pointerup', function () { arrastrando = false; });
    handle.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
    comp.addEventListener('click', function (e) { mover(e.clientX); });
  });
}

function initTiltTarjetas() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 768px)').matches) return;
  document.querySelectorAll('[data-pt-tilt]').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  });
}
